import {
	BROWSE_FILTER_NAME,
	DEFAULT_RECOMMENDATIONS_LIMIT,
	DEFAULT_SECTION,
	EXCLUDE_CURRENTLY_UNAVAILABLE,
	RECOMMENDATIONS_PAGE_TYPES,
	SEEDED_PAGE_TYPES
} from './constants';
import {transformFilters} from './transform-search-request';

/**
 * @param {RecommendationsRequest} request
 * @returns {string[]}
 */
const seedItemIdsFrom = request => {
	const listFrom = value => {
		if (value === '' || value === null || typeof value === 'undefined') {
			return [];
		}

		const list = Array.isArray(value) ? value : String(value).split(',');

		return list.map(id => String(id).trim()).filter(Boolean);
	};

	const ids = listFrom(request.productIds);

	return [...new Set(ids.length ? ids : listFrom(request.productId))];
};

/**
 * @typedef {object} RecommendationsRequest
 * @property {string} [categoryId]
 * @property {import('custom-extensions/search/lib/api/types').SearchRequestFilter[]} [filters]
 * @property {number} [limit]
 * @property {string} [page]
 * @property {string} podId
 * @property {string|number} [productId]
 * @property {string|number[]|string} [productIds]
 * @property {string} [section]
 * @property {string} [term]
 *
 * @typedef {object} TransformedRecommendationsRequest
 * @property {import('@constructor-io/constructorio-client-javascript').RecommendationsParameters} parameters
 * @property {string} podId
 * @property {string[]} seedItemIds
 *
 * @param {RecommendationsRequest} request
 * @returns {TransformedRecommendationsRequest}
 */
export const transformRecommendationsRequest = request => {
	const page = request.page || RECOMMENDATIONS_PAGE_TYPES.PDP;
	const seedItemIds = SEEDED_PAGE_TYPES.includes(page) ? seedItemIdsFrom(request) : [];
	const filterList = [...request.filters || []];

	if (EXCLUDE_CURRENTLY_UNAVAILABLE) {
		filterList.push({
			background: true,
			field: 'currently_unavailable',
			value: 'False'
		});
	}

	if (page === RECOMMENDATIONS_PAGE_TYPES.PLP && request.categoryId) {
		filterList.push({
			background: true,
			field: BROWSE_FILTER_NAME,
			value: String(request.categoryId)
		});
	}

	return {
		parameters: {
			...transformFilters(filterList),
			numResults: parseInt(request.limit || DEFAULT_RECOMMENDATIONS_LIMIT, 10),
			section: request.section || DEFAULT_SECTION,
			...seedItemIds.length ? {itemIds: seedItemIds} : {},
			...request.term ? {term: request.term} : {}
		},
		podId: request.podId,
		seedItemIds
	};
};
